<script>
export default {};
</script>

<template lang="pug">
div(:class="$style.root")
  slot
</template>

<style module lang="sass">
.root
  display: flex
  align-items: stretch

</style>
